import api from 'axios';
import {apiUrl, isNeedToSecure} from "../App";

export async function checkAuthentication(): Promise<boolean> {
    if (isNeedToSecure === "false") {
        return true;
    }

    try {
        const response = await api.get(`${apiUrl}/auth/token/admin/validate`);

        if (response.status === 200) {
            return true;
        } else if (response.status === 403) {
            return false;
        } else {
            console.error('Authentication failed with status:', response.statusText);
            return false;
        }
    } catch (error) {
        return false;
    }
}
